import { LuMoon, LuSun } from "react-icons/lu";
import { useContext } from "react";
import { ThemeContext } from "../theme/ThemeContext";

export default function Navbar() {
    const { theme, setTheme } = useContext(ThemeContext);

    return (
        <nav className="fixed w-full z-50 bg-ivory/90 dark:bg-charcoal/90 backdrop-blur-md">
            <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">

                <a href="/" className="flex items-center gap-3">
                    <img
                        src="/assets/images/logo_transparent.png"
                        alt="M R Suites Dharwad Logo"
                        className="h-12 w-auto object-contain dark:invert"
                    />

                    <h1 className="text-xl font-serif text-gold tracking-wide">
                        M R Suites Dharwad
                    </h1>
                </a>

                <div className="flex items-center gap-6 text-sm text-charcoal dark:text-ivory">
                    <a href="/" className="hover:text-gold">Home</a>
                    <a href="/about" className="hover:text-gold">About</a>
                    <a href="/#rooms" className="hover:text-gold">Rooms</a>
                    <a href="/#gallery" className="hover:text-gold">Gallery</a>
                    <a href="/#contact" className="hover:text-gold">Contact</a>

                    <button
                        onClick={() => setTheme(theme === "light" ? "dark" : "light")}
                        className="border border-gold p-2 rounded-full text-gold hover:bg-gold hover:text-charcoal transition"
                        aria-label="Toggle theme"
                    >
                        {theme === "light" ? <LuMoon size={18} /> : <LuSun size={18} />}
                    </button>
                </div>
            </div>
        </nav>
    );
}